module.exports = __webpack_public_path__ + "static/media/md-briefcase.bca8927d.svg";